import React, { useState, useEffect } from 'react';
import * as classes from './index.module.css';
import PropTypes from 'prop-types';
import Logos from '@Src/svgs/Logo';
import { Link } from 'gatsby';

const Logo = ({ location }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [animateLogo, setAnimateLogo] = useState(false);

  // ✅ Scroll listener
  useEffect(() => {
    const checkScroll = () => setIsScrolled(window.scrollY >= 100);
    window.addEventListener('scroll', checkScroll);
    return () => window.removeEventListener('scroll', checkScroll);
  }, []);

  // ✅ Function to trigger animation for 1.5s
  const triggerAnimation = () => {
    setAnimateLogo(true);
    setTimeout(() => setAnimateLogo(false), 2000);
  };

  // ✅ Run once on mount
  useEffect(() => {
    triggerAnimation();
  }, []);

  // ✅ Re-run when Gatsby route updates
  useEffect(() => {
    const handleRouteChange = () => {
      triggerAnimation();
    };

    window.addEventListener('gatsby:routeUpdated', handleRouteChange);
    return () => {
      window.removeEventListener('gatsby:routeUpdated', handleRouteChange);
    };
  }, []);

  const logoClass = `${classes.svg} ${animateLogo ? 'animated-logo' : 'static-logo'}`;

  return (
    <div className={classes.logo}>
      {location?.pathname === '/' ? (
        <h1 className={classes.title}><Logos className={logoClass} /></h1>
      ) : (
        <Link to="/" title="Greatsweb" className={classes.title}>
          <Logos className={logoClass} />
        </Link>
      )}
    </div>
  );
};

export default Logo;

Logo.propTypes = {
  location: PropTypes.object,
};
